// mep client (Angular) 의 NavigationService 와 동일 정책을 React 앱에 적용.
// - meptoolhub.dcs.co.kr 에 iframe 으로 embed 된 경우만 home 버튼을 숨기고
//   home 동작을 부모(meptoolhub)에게 위임한다.

const MEPTOOLHUB_ORIGIN = 'https://meptoolhub.dcs.co.kr';
const HOME_MESSAGE_TYPE = 'mep:navigate-home';
// 부모 listener 없을 경우 폴백으로 top.location 을 이 주소로 이동
const PARENT_HOME_FALLBACK_URL = 'https://meptoolhub.dcs.co.kr/';
// 부모 listener 응답 대기 시간 — 그 안에 부모가 navigation 하지 않으면 폴백
const FALLBACK_DELAY_MS = 400;
// sessionStorage 키 — iframe 내부 navigation 후에도 첫 referrer 판단을 유지
const EMBEDDED_FLAG_KEY = 'mep:embeddedByMeptoolhub';

let cachedEmbeddedByMeptoolhub: boolean | null = null;

export function isEmbedded(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function isEmbeddedByMeptoolhub(): boolean {
  if (cachedEmbeddedByMeptoolhub !== null) return cachedEmbeddedByMeptoolhub;
  if (!isEmbedded()) return (cachedEmbeddedByMeptoolhub = false);

  try {
    const cached = sessionStorage.getItem(EMBEDDED_FLAG_KEY);
    if (cached === 'true') return (cachedEmbeddedByMeptoolhub = true);
    if (cached === 'false') return (cachedEmbeddedByMeptoolhub = false);
  } catch {
    // sessionStorage 접근 거부 — referrer 만으로 판단
  }

  const matched = isReferrerMeptoolhub();
  try {
    sessionStorage.setItem(EMBEDDED_FLAG_KEY, matched ? 'true' : 'false');
  } catch {
    // ignore
  }
  return (cachedEmbeddedByMeptoolhub = matched);
}

function isReferrerMeptoolhub(): boolean {
  if (!document.referrer) return false;
  try {
    return new URL(document.referrer).origin === MEPTOOLHUB_ORIGIN;
  } catch {
    return false;
  }
}

// iframe embed 시 부모에게 home 이동 요청. 직접 접속 시에는 '/' 로 이동.
export function navigateToHome(): void {
  if (!isEmbedded()) {
    window.location.href = '/';
    return;
  }

  try {
    window.parent.postMessage({ type: HOME_MESSAGE_TYPE }, '*');
  } catch {
    // postMessage 자체는 실패하는 일이 거의 없음
  }

  setTimeout(() => {
    try {
      if (window.top) {
        window.top.location.href = PARENT_HOME_FALLBACK_URL;
      }
    } catch {
      // 일부 sandbox 설정에서 top.location 접근이 거부될 수 있음.
    }
  }, FALLBACK_DELAY_MS);
}
